import {
  type ReportConfigAddInput,
  type ReportConfigAddSuccess,
  type ReportConfigData,
  type UnsavedReportConfigData,
  toResponseError,
} from '@terros/common'
import { type AddHookResponse, mutationAdd } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useReportConfigCache } from './cache'

export function useAddReportConfig(): AddHookResponse<UnsavedReportConfigData, ReportConfigData> {
  const cache = useReportConfigCache()

  const mutation = useTantalimMutation<ReportConfigAddInput, ReportConfigAddSuccess>({
    url: '/report/config/add',
  })

  async function add(unsaved: UnsavedReportConfigData): Promise<ReportConfigData> {
    try {
      const { reportConfig } = await mutation.mutateAsync({ reportConfig: unsaved })
      cache.addItem(reportConfig)
      return reportConfig
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
